export const BetLoopFeedPageSize = 25
